export default {
  tabs: {
    private: 'My',
    public: 'Public',
    nearby: 'Nearby',
    followed: 'Followed',
    daily: 'Daily',
    all: 'Global',
    myHubs: 'My',
    exploreHubs: 'Explore'
  },
  comments: {
    placeholder: 'Write a comment...',
    add: 'Post Comment',
    postComment: 'Post comment',
    reply: 'Reply',
    cancel: 'Cancel',
  },
  buttons: {
    edit: 'Edit',
    delete: 'Delete',
    finish: 'Finish',
    publish: 'Publish',
    cancel: 'Cancel',
    chat: 'Chat',
    leave: 'Leave',
    uploadGpx: 'Upload GPX',
    confirmGpx: 'Save GPX',
    downloadGpx: 'Download GPX',
    moveToContext: 'Move to context',
  },
  accordions: {
    addSocialMedia: 'Add Social Media'
  },
  freaks: {
    visibility: {
      public: 'Public',
      private: 'Private',
      daily: 'Daily',
      weekly: 'Weekly',
      monthly: 'Monthly',
      yearly: 'Yearly',
      campaign: 'Campaign',
      promotion: 'Promotion',
      freak_hub: 'FreakHub'
    },
    status: {
      inProgress: 'In progress',
      finished: 'Finished',
      planned: 'Planned',
      canceled: 'Cancelled'
    },
    operations: {
      start: 'Start',
      join: 'Join',
      requested: 'Requested'
    },
    participate: {
      pending: 'Pending',
      approved: 'Approved',
      declined: 'Declined',
      requestJoin: 'Requested Join'
    },
    emptyList: 'No freaks are here yet.',
    emptyListDaily: 'No feed yet. Create some! ;)',
    emptyListFollowed: 'No Freaks to show',
    deleted: 'Freak has been deleted ;(',
    unauthorized: 'You have to accept invitation first',
    favourited: 'Likes',
    loading: 'Loading Freaks'
  },
  profile: {
    editMessage: 'Edit',
    freaks: 'Freaks',
    followers: 'Followers',
    following: 'Following',
    points: 'Freak Points',
    verified: 'freak-land.com',
    prizeHistory: 'My Prices',
    topFeeds: 'Top Feeds',
    freakFeeds: 'Active in Freak Feeds',
    freakHubs: 'Active in Freak Hubs',
    mainContext: 'Main context',
    ambassador: 'Context Ambassador',
    ambassadorGifts: 'Ambassador Rewards',
    ambassadorGiftsSubline: 'Check back regularly — we add new perks and physical gifts for active ambassadors over time.',
    howToGain: 'How to earn',
    giftTypeRecognition: 'Visibility',
    giftTypePhysical: 'Physical gift',
    giftTypeDigital: 'Digital',
    giftTypeDiscount: 'Discount',
    giftTypeExperience: 'Experience',
    giftValue: 'Value',
  },
  articles: {
    my: 'My Articles',
    favourited: 'Favorited Articles',
    emptyList: 'No articles are here... yet.'
  },
  freakItems: {
    title: 'Freak Things',
    add: 'Add a Freak Thing',
    empty: 'No things yet',
    name: 'Name',
    category: 'Category',
    customCategory: 'Own category…',
    brand: 'Brand',
    model: 'Model',
    year: 'Year',
    purchaseDate: 'Purchase date',
    description: 'Description',
    specs: 'Specs',
    addSpec: 'Add spec',
    public: 'Visible on profile',
    save: 'Save',
    delete: 'Delete',
    deleteConfirm: 'Delete this thing?',
    usageStats: 'Usage',
    activities: 'Activities',
    distance: 'Distance',
    time: 'Time',
    linkedFreaks: 'Used on',
    gearUsed: 'Gear used',
  },
  contextPicker: {
    customize: 'Customize',
    customizeTitle: 'Choose contexts to show',
    customizeHint: 'Only the selected contexts appear in the switcher. You can change this anytime.',
    showAll: 'Show all',
    save: 'Save',
    cancel: 'Cancel',
    selectAtLeastOne: 'Select at least one context',
  },
  settings: {
    title: 'Settings',
    logout: 'Logout',
    shakeIt: 'Shake It!',
    forceReload: 'Force reload app',
    version: 'Version',
    update: 'Save',
    bio: "Short bio about you",
    bioLabel: 'Bio',
    socialLinksLabel: 'Social links',
    userImageLabel: 'Upload User Image',
    backgroundImageLabel: 'Background Image',
    modeLabel: 'Mode',
    modeLabelDescription: 'Change to dark mode.',
    languageLabel: 'Language',
    languageLabelDescription: 'Choose langugage.',
    languagePolish: 'Polish',
    languageEnglish: 'English',
    contextLabel: 'Default Context',
    settings: 'Settings',
    notifications: 'Request notifications permissions',
    customNotifications: 'Custom notifications',
    customNotificationsDescription: 'Get notified about new activities near your places',
    mushroomRadarNotification: '🍄 Mushroom radar',
    fishingNearbyNotification: 'Fishing radar',
    contextWof: 'Wild Off Road',
    contextBike: 'Bikes',
    contextFishing: 'Fishing',
    contextTrip: 'Trip',
    contextFit: 'Fit',
    contextRunning: 'Running',
    contextDogs: 'Pets',
    contextGames: 'Games',
    contextBooks: 'Books',
    contextFood: 'Food',
    contextShopping: 'Shopping',
    contextTech: 'Tech',
    contextMotorization: 'Motorization',
    contextGardening: 'Gardening',
    contextMusic: 'Music',
    contextSport: 'Sport',
    contextWinterSports: 'Winter Sports',
    contextHorseRiding: 'Horse Riding',
    contextMovies: 'Movies',
    contextSeries: 'Series',
    contextSkateboard: 'Skateboard',
    contextInlineSkate: 'Inline Skate',
    contextScooter: 'Scooter',
    contextBmx: 'Bmx',
    contextMushroom: 'Mushroom',
    contextNordicWalking: 'Nordic Walking',
    switchThemeDark: 'Switch to dark theme',
    switchThemeLight: 'Switch to light theme',
    theme: 'Theme'
  },
  modals: {
    confirmation: {
      areYouSure: 'Are you sure?',
      actionUndone: 'This action cannot be undone.',
      confirm: 'Confirm',
      decline: 'Decline',
      emailHasBeenSent: 'Confirmation email has been sent.',
      ok: 'OK'
    },
    tooManyRequests: {
      niceTry: 'Nice try 😉 Sorry, but you have exceeded your daily limit. Come back to us tomorrow, or...',
      youHaveReachedYourLimit: 'You have exceeded your daily limit. Come back to us tomorrow, or...',
      register: 'Register for free to get full access 🥳',
      buyMeACoffee: 'If you like our app 🙃',
      newsletter: 'Subscribe to Newsletter'
    },
    moveContext: {
      title: 'Move to another context',
      hint: 'The freak will show up in the chosen context.'
    }
  },
  editor: {
    placeholders: {
      postTitle: 'Title',
      postContent: 'Content'
    },
    save: 'Save'
  },
  freakEditor: {
    placeholders: {
      freakTitle: 'Title',
      freakContent: 'Content'
    },
    defaults: {
      body: 'My latest Freak!'
    },
    add: 'Add',
    save: 'Save',
    isPrivateLabel: 'Freak visibility',
    private: 'Private',
    public: 'Public',
    freakVisibility: 'Settings',
    createPlace: 'Create a Private Place',
    showInPlaces: 'Show in Places',
    createFreaks: 'Create Freaky!',
    createTrack: 'Create track!',
    requestTrack: 'Request track recording',
    trackRequested: 'Track recording requested',
    freakRouteMobileAppNeeded: 'Install mobile📱or watch⌚app and create Freak route.',
    freakyMobileAppNeeded: 'Install mobile📱or watch⌚app and create Freaky.',
    deleteRoute: 'Delete route',
    createTitle: 'Create freak',
    editTitle: 'Edit freak',
    post: 'Post',
    update: 'Update',
    titlePlaceholder: 'Give your freak a title',
    bodyPlaceholder: 'What\'s happening out there?',
    titleRequired: 'Add a title to post your freak',
    addToFreak: 'Add to your freak',
    photo: 'Photo',
    camera: 'Camera',
    tagPeople: 'Tag people',
    location: 'Location',
    hub: 'FreakHub',
    route: 'Route (GPX)',
    dateTime: 'Date & time',
    links: 'Links',
    audienceTitle: 'Who can see your freak?',
    publicDescription: 'Anyone on Freakland',
    privateDescription: 'Only you and the people you tag',
    with: 'with',
    in: 'in',
    at: 'at',
    now: 'Now',
    uploading: 'Uploading photos…',
    searchLocation: 'Search for an address',
    myPlaces: 'Choose from my places',
    currentLocation: 'Current location',
    linksTitle: 'Add links',
    done: 'Done',
    remove: 'Remove',
    removePhotoConfirm: 'Remove this photo from the freak?',
    removeRouteConfirm: 'Remove this route from the freak?',
    discardTitle: 'Discard this freak?',
    discardMessage: 'Your changes will be lost.',
    discard: 'Discard',
    keepEditing: 'Keep editing',
    changeDate: 'Change date',
    changeTime: 'Change time',
    create: 'Create freak',
    edit: 'Edit freak',
    photosTitle: 'Add photos'
  },
  campaignEditor: {
    placeholders: {
      freakTitle: 'Title',
      freakContent: 'Content'
    },
    add: 'Add',
    save: 'Save',
    isPrivateLabel: 'Private Campaign',
    freakVisibility: 'Settings'
  },
  freakPlacesEditor: {
    placeholders: {
      title: 'Title',
      content: 'Description'
    },
    isPrivateLabel: "Private Freak place",
    private: 'Private',
    public: 'Public',
    createTitle: 'Add place',
    editTitle: 'Edit place',
    save: 'Add',
    update: 'Update',
    namePlaceholder: 'Name your place',
    descriptionPlaceholder: 'What makes this place special?',
    required: 'Add a name, a short description and a location to save your place',
    privateInfo: 'Private place · only you and the people you add can see it',
    addPhotos: 'Add photos',
    addToPlace: 'Add to your place',
    addPeople: 'Add people',
    location: 'Location',
    pickLocation: 'Where is it? Tap to pick a location',
    useCurrentLocation: 'Use my current location',
    links: 'Links',
    linksTitle: 'Add links',
    website: 'Website',
    youtube: 'YouTube channel',
    facebook: 'Facebook page',
    instagram: 'Instagram profile',
    discardTitle: 'Discard this place?',
    create: 'Add place',
    edit: 'Edit place'
  },
  freakCampaigns: {
    noCampaigns: 'No Campaigns for now, check soon.',
    contact: 'Do you want to create a campaign?',
    contactButton: 'Contact us!',
    winPrice: 'Go to Shake Freak!',
    everyDayWin: 'Every win!'
  },
  freakView: {
    filter: 'Filter:',
    search: 'Search...',
    yourLocation: 'Your localization',
    sortBy: 'Sort by:',
    likes: 'Likes',
    status: 'Status',
    planned: 'Planned',
    canceled: 'Canceled',
    finished: 'Finished',
    inProgress: 'In Progress',
    date: 'Create date',
    dateFrom: 'Date from',
    dateTo: 'Date to',
    asc: 'Ascending',
    desc: 'Descending',
    none: 'None',
    participant: 'Participant/Author'
  },
  freakPreview: {
    messages: {
      plannedTo: 'Planned to',
      finishedAt: 'Finished at',
      alreadyRunning: 'Already running'
    },
    copy: {
      copyLink: 'Copy Link',
      copied: 'Copied!',
      failed: 'Failed to copy'
    },
    share: {
      checkoutThis: 'Checkout this !'
    },
    requestTrackAccess: {
      button: '',
      dialogTitle: 'GPS Track Recording — Early Access',
      dialogBody: 'Real-time GPS route tracking is currently available to selected users only. To request access, send an email with your registered email address.',
      emailSubject: 'Track Access Request',
      emailCta: 'Send Request',
      close: 'Close',
    },
  },
  moderation: {
    pending: 'Waiting for admin approval',
    rejected: 'Not approved by admin',
  },
  freakActions: {
    organizer: 'Organizer',
    going: {
      one: '{count} going',
      few: '{count} going',
      many: '{count} going',
    },
    joinRequests: {
      one: '{count} join request',
      few: '{count} join requests',
      many: '{count} join requests',
    },
    ownerTitle: 'You\'re organizing this freak',
    ownerHintPlanned: 'Start it when the crew is ready to go.',
    ownerHintInProgress: 'It\'s live! Finish it when everyone\'s back.',
    ownerHintFinished: 'This freak is finished. Nice one!',
    ownerHintCanceled: 'This freak was cancelled.',
    ownerHintFeed: 'Your feed is live for everyone in this context.',
    participantTitle: 'You\'re in!',
    participantHint: 'Chat with the crew, share photos and tracks below.',
    requestedTitle: 'Request sent',
    requestedHint: 'The organizer will review it soon. We\'ll notify you.',
    invitedTitle: 'You\'re invited',
    invitedHint: 'Accept the invitation in your notifications to join.',
    declinedTitle: 'Request declined',
    declinedHint: 'The organizer didn\'t accept your request this time.',
    guestTitle: 'Want to join?',
    guestHint: 'Send a request — the organizer decides who\'s in.',
    closedHint: 'This freak is no longer open for new members.',
    joinCta: 'Join this freak',
    start: 'Start freak',
    finish: 'Finish freak',
    more: 'More',
    comments: 'Comments',
    confirm: {
      start: {
        title: 'Start this freak?',
        message: 'Participants will see it as live.',
      },
      finish: {
        title: 'Finish this freak?',
        message: 'The finish time will be saved and the freak closed.',
      },
      cancel: {
        title: 'Cancel this freak?',
        message: 'Participants will see it as cancelled.',
      },
      delete: {
        title: 'Delete this freak?',
        message: 'Photos, comments and tracks will be removed. This action cannot be undone.',
      },
      leave: {
        title: 'Leave this freak?',
        message: 'You\'ll need to request to join again to come back.',
      },
      keep: 'Not now',
    },
  },
  freakDetails: {
    localization: 'Localization',
    localizationDescription: 'Event venue',
    plannedTo: 'Planned to',
    startedAt: 'Started at',
    finishedAt: 'Finished at',
    duration: 'Duration',
    checkOnGoogleMaps: 'Check on Google Maps',
    noParticipants: 'No participants yet...',
    participants: 'Participants',
    participantsDescription: 'Freaks in event',
    description: 'Description',
    linkToArticle: 'Link to site',
    information: 'Info',
    informationDescription: 'Start, end, duration event time',
    socialMedia: 'Social Media',
    socialMediaDescription: 'Youtube, Facebook, Instagram',
    likes: 'Likes',
    route: 'Route',
    activity: 'Activity'
  },
  freakParticipants: {
    remove: 'Remove'
  },
  freakSelect: {
    placeholders: {
      selectParticipants: 'Select participants',
      searchParticipants: 'Type username',
      selectPlace: 'Select place',
      searchPlace: 'Type place',
    }
  },
  freakHubSelect: {
    placeholders: {
      selectFreakHub: 'Select FreakHub',
      searchFreakHub: 'Type FreakHub name',
    }
  },
  freakLocalization: {
    placeholders: {
      search: 'Search for a location...'
    },
    yourLocalization: 'Your localization',
    distance: 'At a distance from you',
    all: 'All',
    markerIsDraggable: 'Marker is draggable',
    clickToDragMarker: 'Click here to make marker draggable',
    filter: {
      header: 'Filter',
      status: 'Status',
      participant: 'Participant',
      localization: 'Lokalizacja'
    },
    sort: {
      header: 'Sort',
      likes: 'Likes',
      date: 'Date'
    }
  },
  freakCampaign: {
    participantsDescription: 'Freaks in campaign',
    cooperation: 'Cooperation',
    cooperationBody: 'Want to create your own Campaigns?',
    contact: 'Write to us',
    requestContact: 'or request contact and we will contact to You',
    requestCampaign: 'Request Campaign sent',
    close: 'Close'
  },
  notifications: {
    types: {
      invitation: 'Invitation',
      info: 'Info',
      requestJoin: 'Request join'
    },
    emptyList: 'You don\'t have any notification',
    accept: 'Accept',
    decline: 'Decline',
    show: 'Show',
    delete: 'Delete',
    denied: 'Notifications permissions denied.',
    settings: 'Notifications settings'
  },
  giphy: {
    placeholders: {
      search: 'Search for GIFs'
    }
  },
  uploadFiles: {
    upload: 'Select files (png, jpg, jpeg, heic). Limit 10mb.',
    notSupportedFileType: 'Not supported file type',
    somethingWentWrong: 'Something went wrong, try again',
    tooLargeFile: 'Too large file. Limit 10mb.',
    locationChoice: {
      title: 'Photo location',
      message: 'Choose which location to attach to the photo',
      useExif: 'Use location from photo',
      useCurrent: 'Use current location',
      withoutLocation: 'Without location',
    },
  },
  datePicker: {
    placeholders: {
      select: 'Select date'
    }
  },
  login: {
    needAccount: 'Need an account?',
    tryUsFirst: 'or try us first 🙃',
    addToHomeScreen: 'Add to Home Screen',
    signIn: 'Sign In',
    password: 'Password',
    forgotPassword: 'Forgot Password?',
    buttons: {
      signIn: 'Sign In'
    }
  },
  resetPassword: {
    label: 'Reset Password',
    sendEmail: 'Send Email'
  },
  setupPassword: {
    setupNew: 'Setup New Password',
    placeholders: {
      password: 'Password',
      confirmPassword: 'Confirm Password'
    },
    confirm: 'Confirm'
  },
  register: {
    signUp: 'Sign Up',
    haveAnAccount: 'Have an account?',
    emailSent: 'Confirmation email has been sent.',
    termsOfService: 'By signing up to create an account I accept',
    termsOfServiceTitle: 'Terms of Service',
    termsOfServiceAnd: 'and',
    privacyPolicy: 'Privacy Policy',
    placeholders: {
      username: 'Username',
      password: 'Password',
      birthDate: 'Date of birth'
    },
    defaultContext: 'Freak',
    birthDateHint: 'Freakland is for people aged 16 and over. We use your date of birth only to check your age.'
  },
  readMoreComponent: {
    more: 'Read more...',
    less: 'Read less...'
  },
  linksPlace: {
    placeholders: {
      add: 'Add Place link here...',
      invalidLink: 'Invalid link',
    }
  },
  linksYoutube: {
    placeholders: {
      add: 'Add YouTube link here...',
      addFeed: 'Add YouTube channel here...',
      invalidLink: 'Invalid link',
      invalidFeed: 'Invalid channel'
    }
  },
  linksFacebook: {
    placeholders: {
      add: 'Add Facebook link here...',
      invalidLink: 'Invalid link',
      groupMessenger: 'Add Messenger link to Your Group...'
    }
  },
  linksInstagram: {
    placeholders: {
      add: 'Add Instagram link here...',
      invalidLink: 'Invalid link'
    }
  },
  linksX: {
    placeholders: {
      add: 'Add X link here...',
      invalidLink: 'Invalid link'
    }
  },
  bottomNavigation: {
    freaks: 'Freaks',
    notifications: 'Notifications',
    messages: 'Chat',
    places: 'Places',
    campaigns: 'Campaigns',
    record: 'Freak'
  },
  leftNavigation: {
    add: 'Add',
    freaks: 'Freak',
    notifications: 'Notifications',
    messages: 'Messages',
    places: 'Places',
    hub: 'Freak Hub',
    campaigns: 'Campaigns',
    topFreaks: 'Top Freaks',
    theFreaks: 'The Freaks',
    context: 'Context',
    filters: 'Filters',
    profile: 'Profile'
  },
  freakPlaces: {
    navigate: 'Check on:',
    noFishingPlaces: 'No fishing places available yet — add one to see prediction, catches and weather.',
    filterPlaceholder: 'Filter places by name…',
    sharePlace: 'Share place',
    copyLink: 'Copy link',
    copied: 'Copied!',
    copyFailed: 'Failed to copy',
    details: 'Details',
    edit: 'Edit',
    sendForPublic: 'Request change to public place',
    waitingForApproval: 'Waiting for approval',
    delete: 'Delete',
    freaksFromThisPlace: 'From this place:',
    noFreaksFromThisPlace: 'No Freaks from this place yet.',
    restrictedView: 'Register to Get Full Access',
    restrictedView2: 'Unlock all features by creating an account.',
    restrictedView3: 'Already have an account?',
    registerToGetFullAccess: 'Join',
    fishing_pzw: 'PZW',
    fishing_commercial: 'Commercial',
    fishing_white_card_only: 'White card only',
    wof_motocross: 'Off-road',
    winter_sports_ski_resort: 'Ski Resort',
    winter_sports_snowpark: 'Snowpark',
    bike_green: 'Green trails',
    bike_blue: 'Blue trails',
    bike_red: 'Red trails',
    bike_black: 'Black trails',
    loadingFreakPlaces: 'Loading Freak Places...'
  },
  contextSwipeableDrawerComponent: {
    title: 'Context',
    close: 'Close',
    resetAllFilters: 'Reset All Filters'
  },
  filterSwipeableDrawerComponent: {
    title: 'Settings'
  },
  snackbar: {
    open: 'Open',
    denied: 'Notifications denied.'
  },
  emailConfirmed: {
    message: 'Email confirmed.',
    buttonMessage: 'Log in'
  },
  reportAbuse: {
    report: 'Report abuse',
    spam: 'Spam or Scam',
    hate: 'Contains hate speech or attacks an individual',
    violence: 'Violence or harmful behaviour',
    nudity: 'Nudity, pornography, or sexually explicit content',
    duplicate: 'Duplicate, fake, or miscategoriezed content',
    harassment: "Harassment or harmful behaviour",
    copyright: "Copyright",
    misinformation: "Misinformation",
    other: "Other"
  },
  topFreaks: {
    title: "Top Freak'ów",
    points: "Freak points"
  },
  topFeeds: {
    title: "Top Feeds",
  },
  pricesHistory: {
    title: 'Historia nagród'
  },
  followedBy: {
    title: 'Your Followers',
    noBio: 'No bio'
  },
  following: {
    title: 'Following',
    noBio: 'No bio'
  },
  userBlock: {
    reportUser: "Report user",
    reportUserDescription: "Select the reason for reporting this user",
    block: "Block user",
    unblock: "Unblock",
    blockConfirmTitle: "Block {username}?",
    blockConfirmMessage: "You won't see each other's freaks, comments or Blasts, and you'll stop following each other. They won't be notified.",
    blockConfirm: "Block",
    cancel: "Cancel",
    send: "Send",
    blocked: "You blocked {username}",
    blockedInfo: "Their content is hidden. Unblock to see it again.",
    blockedToast: "User blocked",
    unblockedToast: "User unblocked",
    reportedToast: "Report sent — thank you",
    error: "Something went wrong",
    empty: "You haven't blocked anyone",
    blockedUsers: "Blocked users",
    blockedUsersDescription: "People you blocked — unblock them here",
  },
  profileFavorites: {
    follow: 'Follow',
    unfollow: 'Unfollow'
  },
  usersList: {
    title: 'Users'
  },
  errors: {
    error401Message: 'Back to Freaks.',
    error404Message: 'Back to Freaks.',
  },
  shortsCreator: {
    retake: 'Retake',
    save: 'Save'
  },
  freakLocalizationTracker: {
    liveMinutesAgo: 'Live · {count} min ago',
    you: 'You',
    live: 'live',
    distance: 'Distance:',
    duration: 'Duration:',
    movingTime: 'Moving Time:',
    speed: 'Speed',
    maxSpeed: 'Max Speed:',
    avgSpeed: 'Avg Speed:',
    altitude: 'Altitude:',
    maxAltitude: 'Max Altitude:',
    calories: 'Calories:',
    hydration: 'Hydration:',
    avgHeartRate: 'Avg Heart Rate:',
    maxHeartRate: 'Max Heart Rate:'
  },
  freakTrackerView: {
    resume: 'Resume',
    start: 'Start',
    pause: 'Pause',
    finish: 'Finish',
    clear: 'Clear',
    cancel: 'Cancel',
    confirm: 'Confirm',
    pauseConfirm: 'Your progress will be saved.',
    finishConfirm: 'Your route will be saved.',
    clearConfirm: 'All recorded data will be lost.',
    discard: 'Discard',
    discardTitle: 'Discard this track?',
    finishTitle: 'Finish tracking?',
    time: 'Time',
    distance: 'Distance',
    speed: 'Speed',
    pace: 'Pace',
    avgSpeed: 'Avg speed',
    avgPace: 'Avg pace',
    maxSpeed: 'Max speed',
    elevation: 'Max elevation',
    recording: 'Recording',
    paused: 'Paused',
    gpsSearching: 'Searching GPS…',
    gpsGood: 'GPS ready',
    gpsWeak: 'Weak GPS',
    showStats: 'Show all stats',
    showMap: 'Show map',
    recenter: 'Center on me',
    back: 'Back',
  },
  freakPlacesList: {
    fromThisPlace: 'Freaks from this place:',
    filter: 'Filter',
  },
  cometChat: {
    CHATS: 'Chats',
    USERS: 'Users',
    DELETE: 'Yes',
    CANCEL: 'Cancel',
    DELETE_CONVERSATION: 'Delete Conversation?',
    WOULD__YOU_LIKE_TO_DELETE_THIS_CONVERSATION: 'Would you like to delete this conversation?'
  },
  feeds: {
    title: "Feeds",
    subscribe: 'Subscribe'
  },
  shake: {
    shakeToWin: 'Shake to win!',
    win: 'Your price is:',
    onlyOnePerDay: 'You have only one shake per day, next shake in:',
    permissions: 'Please grant permission to detect device motion.',
    loading: 'Loading reward... Please come back in a minute or refresh the page',
    visitShop: 'Visit our Freak Shop!'
  },
  hubs: {
    view: 'View',
    join: 'Join',
    emptyList: 'No FreakHubs',
    privateView: 'Allowed only for FreakHub participants',
    editMessage: 'Edit',
    deleteMessage: 'Delete'
  },
  hubDetails: {
    freaksCount: 'Freaks',
    usersCount: 'Users',
    createdAt: 'Created at',
    join: 'Join'
  },
  hubEditor: {
    defaults: {
      title: 'Freak Hub',
      body: 'New Freak Hub!'
    },
    placeholders: {
      title: 'Title',
      content: 'Description'
    },
    save: 'Save',
    createTitle: 'Create FreakHub',
    editTitle: 'Edit FreakHub',
    update: 'Update',
    namePlaceholder: 'Name your hub',
    descriptionPlaceholder: 'What is this hub about? Who should join?',
    required: 'Add a name and a description to create your hub',
    publicInfo: 'Public hub · anyone on Freakland can find it',
    addCover: 'Add cover photo',
    changeCover: 'Change cover',
    addPhoto: 'Hub photo',
    addToHub: 'Add to your hub',
    inviteMembers: 'Invite members',
    members: 'Members',
    discardTitle: 'Discard this hub?',
    createAction: 'Create'
  },
  hubUsers: {
    title: 'Users in'
  },
  placesSearch: {
    placeholder: 'Search places…',
    filters: 'Filters',
    nearMe: 'Near me',
    mapArea: 'This map area',
    withPhotos: 'With photos',
    radius: 'Radius',
    clearAll: 'Clear all',
    resultsZero: 'No places',
    resultsOne: '1 place',
    resultsFew: '{0} places',
    resultsMany: '{0} places',
    noResultsTitle: 'No places found',
    noResultsHint: 'Try another phrase or loosen your filters.',
    clearFilters: 'Clear filters',
    locationDenied: 'Allow location access to search places near you.',
    freaksHere: 'Freaks: {0}',
    close: 'Close results',
    loadMore: 'Show more',
  },
  algoliaSearch: {
    search: 'Search...'
  },
  freakPlacesTabs: {
    info: 'Info',
    prediction: 'Prediction',
    catches: 'Catches',
    weather: 'Weather',
  },
  weather: {
    title: 'Weather',
    noData: 'No weather data',
    weekForecast: '7-day forecast',
    today: 'Today',
    temperature: 'Temperature',
    water: 'Water',
    precipitation: 'Precipitation',
    wind: 'Wind',
    pressure: 'Pressure',
    cloudCover: 'Cloud Cover',
    hourlyForecast: 'Hourly forecast',
  },
  fishingPrediction: {
    title: 'Fishing Forecast',
    noData: 'No prediction data',
    noDataForPlace: 'No forecast for this location',
    todayForecast: "Today's forecast",
    weekForecast: '7-day prediction',
    activityHigh: 'High',
    activityMedium: 'Medium',
    activityLow: 'Low',
    fallbackNotice: 'Predictions based on weather conditions — no catch history. Add at least 5 catches to enable the AI model.',
    possibleFish: 'Possible fish',
    saveNewCatch: 'Save new catch',
    saveCatch: 'Save catch',
    bestSpecies: 'Best species',
    activity: 'activity',
  },
  feedback: {
    title: 'Send Feedback',
    subtitle: "We'd love to hear what you think — bug reports, ideas, or general thoughts.",
    contextLabel: 'What is this about?',
    contextOverall: 'Overall / general',
    messageLabel: 'Your message',
    emailLabel: 'Your email (optional, if you want a reply)',
    submit: 'Send',
    successMessage: 'Thanks — your feedback has been sent!',
    errorMessage: 'Something went wrong sending your feedback. Please try again.',
    captchaError: "Please confirm you're not a robot",
  },
  mushroomRadar: {
    button: 'Mushroom radar',
    title: 'Mushrooms — radar',
    loading: 'Loading mushroom data…',
    error: 'Could not load mushroom data.',
    empty: 'No mushroom data available right now.',
    source: 'Source: grzyby.pl',
    close: 'Close',
    updated: 'Updated',
    legendTitle: 'Mushroom occurrence intensity',
    legendLow: 'few',
    legendHigh: 'abundant',
    legendNote: 'Colors come straight from the grzyby.pl radar.',
    legendNoData: 'no data',
  },
  fishingRadar: {
    button: 'Fishing radar',
    title: 'Fishing — radar',
    loading: 'Loading bite forecast…',
    error: 'Could not load the fishing radar.',
    empty: 'No radar data available right now.',
    close: 'Close',
    updated: 'Updated',
    legendTitle: 'Predicted bite activity',
    legendLow: 'poor',
    legendHigh: 'excellent',
    legendNote: 'Heuristic index from weather + moon phase — not a catch guarantee.',
    legendNoData: 'no data',
  },
  quickCreate: {
    buttonA11y: 'Quick create: record a track or post a blast',
    title: 'Quick start',
    subtitle: 'Pick what to capture — we will create a freak for it.',
    close: 'Close',
    track: {
      title: 'Record track',
      hint: 'GPS on, go ride. Saved to a new freak.',
      defaultTitle: 'Track',
      locked: 'Not enabled for you yet',
    },
    blast: {
      title: 'Post blast',
      hint: 'Short video up to 60 s, posted to a new freak.',
      defaultTitle: 'Blast',
    },
    freakLabel: 'Your freak',
    titlePlaceholder: 'Name it (optional)',
    private: 'Private',
    here: 'Current location',
    now: 'Starts now',
    creating: 'Creating your freak…',
    fullEditor: 'Prefer the full editor? Create freak',
    locationNeeded: 'Allow location so we can pin your freak',
    somethingWentWrong: 'Something went wrong, try again',
  },
};
